import { useEffect } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import SimpleModal from "cpl-react-common/components/Modals/SimpleModal";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { createUserGroup, fetchUserGroup, resetUserGroup, selectUserGroup, updateUserGroup } from "./UserGroupSlice";
import { useDispatch, useSelector } from "react-redux";

const validationSchema = () =>
  Yup.object().shape(
    {
      newGroupName: Yup.string().required("A valid name must be entered"),
    },
    []
  );

type UserGroupModalProps = {
  showGroupModal: boolean;
  setShowGroupModal: React.Dispatch<React.SetStateAction<boolean>>;
  userGroupID: number | undefined | null;
  updateSelectedGroupID: ((selectedGroupID: number) => void) | undefined;
  setSelectedUserGroupID: React.Dispatch<React.SetStateAction<number | undefined | null>>;
};

const UserGroupModal = (props: UserGroupModalProps) => {
  const thunkDispatch = useThunkDispatch();
  const dispatch = useDispatch();
  const userGroup = useSelector(selectUserGroup);
  const editingGroup = props.userGroupID != undefined;

  useEffect(() => {
    if (props.userGroupID != undefined) {
      thunkDispatch(fetchUserGroup(props.userGroupID));
      if (props.updateSelectedGroupID != undefined) {
        props.updateSelectedGroupID(props.userGroupID);
      }
    }
  }, [props, thunkDispatch, dispatch]);

  function createGroup(groupName: string | undefined) {
    if (groupName != undefined) {
      thunkDispatch(createUserGroup(groupName));
      props.setShowGroupModal(false);
      dispatch(resetUserGroup());
    }
  }

  function renameGroup(newName: string | undefined) {
    if (newName != undefined && userGroup != undefined) {
      userGroup.groupName = newName;
      thunkDispatch(updateUserGroup(userGroup));
      props.setShowGroupModal(false);
    }
  }

  return (
    <SimpleModal
      modalTitle={editingGroup ? "Rename User Group" : "New User Group"}
      showModal={props.showGroupModal}
      dismissModalCallback={() => {
        props.setSelectedUserGroupID(undefined);
        props.setShowGroupModal(false);
      }}
    >
      <Formik
        initialValues={{ newGroupName: editingGroup ? userGroup?.groupName ?? "" : "" }}
        validationSchema={validationSchema()}
        onSubmit={(values) => (editingGroup ? renameGroup(values.newGroupName) : createGroup(values.newGroupName))}
        enableReinitialize={true}
      >
        {() => {
          return (
            <Form>
              <div className="row mb-6">
                <label className="col-lg-3 col-form-label required fw-bold">Group Name:</label>
                <div className="col-lg-9">
                  <Field
                    data-test-id="user-group-modal__new-group-name-input"
                    type="text"
                    className="form-control form-control-lg form-control-solid"
                    name="newGroupName"
                  />
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      <ErrorMessage name="newUserID" />
                    </div>
                  </div>
                </div>
              </div>
              <button
                data-test-id="user-group-modal__submit-button"
                type="submit"
                className="col-sm-3 btn btn-success btn-sm"
              >
                {editingGroup ? "Rename" : "Create"}
              </button>
            </Form>
          );
        }}
      </Formik>
    </SimpleModal>
  );
};

export default UserGroupModal;
